import { ReactNode } from 'react';
import styles from './HighlightBlock.module.css';
import classNames from '../../utils/classNames';
import AlertLineIcon from '../../atoms/icons/AlertLineIcon';
import InformationLineIcon from '../../atoms/icons/InformationLineIcon';

enum Type {
    Warning = 'warning',
    Info = 'info',
    Error = 'error',
}

type HighLightBlockType = 'warning' | 'info' | 'error' | 'none';

interface Props {
    readonly type?: HighLightBlockType;
    readonly bottomMarginInPx?: number | null;
    readonly children: ReactNode;
}

const HighlightBlock = ({
    type,
    bottomMarginInPx = null,
    children
}: Props) => {

    const renderIcon = (): ReactNode => {
        if (type == Type.Warning) {
            return <AlertLineIcon/>;
        }

        return <InformationLineIcon/>
    }

    return (
        <div
            className={classNames(styles.highlightBlock, type ? styles[type] : null)}
            style={{ marginBottom: bottomMarginInPx !== null ? bottomMarginInPx + 'px' : '0' }}
        >
            {type !== 'none' && (
                <div className={styles.icon}>
                    {renderIcon()}
                </div>
            )}
            <div>
                {children}
            </div>
        </div>
    )
}

export default HighlightBlock
